import { render, staticRenderFns } from "./LocalFormSearch.vue?vue&type=template&id=470f4cac&"
import script from "./LocalFormSearch.vue?vue&type=script&lang=js&"
export * from "./LocalFormSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports